var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { transient, autoinject } from 'aurelia-dependency-injection';
import { BrandingBase } from '../../../../../views/app/admin/branding/branding-base';
import { BaseSyndicate } from '../../base-syndicate';
import { ClientLotteryClientService } from '../../../../../services/modules/client/client-lottery-client-service';
import { Router } from 'aurelia-router';
import { I18N } from 'aurelia-i18n';
import { DialogClientService } from '../../../../../services/basics/dialog-client.service';
import { TokenClient } from '../../../../../services/authentication/token-client.service';
import { NotificationClientService } from '../../../../../services/basics/notification-client.service';
import { EventAggregator } from 'aurelia-event-aggregator';
import { BindingSignaler } from 'aurelia-templating-resources';
import { GamePlayerTicketClientService } from '../../../../../services/modules/client/client-game-player-ticket-client.service';
var Syndicate = /** @class */ (function (_super) {
    __extends(Syndicate, _super);
    function Syndicate(lotteryClientService, router, tokenClientService, notificationClientService, i18N, eventAggregator, dialogClientService, bindingSignaler, gamePlayerTicketClientService) {
        return _super.call(this, lotteryClientService, router, tokenClientService, notificationClientService, i18N, eventAggregator, dialogClientService, bindingSignaler, gamePlayerTicketClientService) || this;
    }
    Syndicate.prototype.navigateToSyndicate = function (syndicate) {
        if (!this.tokenClient.isPreview && this.navigateToSyndicateInternal) {
            this.navigateToSyndicateInternal(syndicate, this.brandLotteryId);
        }
    };
    Syndicate.prototype.navigateToLottery = function (lottery) {
        if (!this.tokenClient.isPreview) {
            this.navigateToLotteryInternal(lottery);
        }
    };
    Syndicate.prototype.navigateToCart = function () {
        if (this.navigateToCartInternal)
            this.navigateToCartInternal(this.lottery);
    };
    Syndicate.prototype.showSteps = function () {
        window.parent.postMessage({
            key: BrandingBase.SelectBrandingKey,
            value: [
                //Text
                "steps-title",
                "steps-step-1-text",
                "steps-step-2-text",
                "steps-step-3-text",
                //Colors
                "steps-title-foreground",
                "steps-step-border",
            ]
        }, window.parent.location.origin);
    };
    Syndicate.prototype.showSwitch = function () {
        window.parent.postMessage({
            key: BrandingBase.SelectBrandingKey,
            value: [
                //Images
                //Text
                "switch-standard-lottery",
                "switch-syndicate",
                //Colors
                "switch-pages-background",
                "switch-pages-foreground",
                "switch-pages-selected-background",
                "switch-pages-selected-foreground",
            ]
        }, window.parent.location.origin);
    };
    Syndicate.prototype.showSyndicateCarousel = function () {
        window.parent.postMessage({
            key: BrandingBase.SelectBrandingKey,
            value: [
                //Text
                "syndicate-name",
                "carousel-combined-lines",
                "carousel-available-shares",
                //Colors
                "carousel-arrow-icon-background",
                "carousel-arrow-icon-foreground",
                "carousel-content-background",
                "carousel-content-selected-background",
                "carousel-name-foreground",
                "carousel-name-selected-foreground",
                "carousel-combined-lines-foreground",
                "carousel-combined-lines-selected-foreground",
                "carousel-available-shares-foreground",
                "carousel-available-shares-selected-foreground"
            ]
        }, window.parent.location.origin);
    };
    Syndicate.prototype.showBanner = function () {
        window.parent.postMessage({
            key: BrandingBase.SelectBrandingKey,
            value: [
                //Text
                "syndicate-name",
                "banner-next-draw",
                //Colors
                "banner-syndicate-background",
                "banner-syndicate-title-foreground",
                "banner-syndicate-country-foreground",
                "banner-syndicate-prize-foreground",
            ]
        }, window.parent.location.origin);
    };
    Syndicate.prototype.showSyndicateDetails = function () {
        window.parent.postMessage({
            key: BrandingBase.SelectBrandingKey,
            value: [
                //Text
                "details-description-title",
                "details-description-desc",
                "details-available-shares",
                "details-total-combined-lines",
                "details-available-numbers",
                "details-shares-title",
                "details-shares-out-of",
                "details-shares-shares-available",
                //Colors
                "details-background",
                "details-description-title-foreground",
                "details-description-desc-foreground",
                "details-totals-background",
                "details-totals-label-foreground",
                "details-totals-value-foreground",
                "details-numbers-title-foreground",
                "details-numbers-num-background",
                "details-numbers-num-foreground",
                "details-numbers-num-bonus-background",
                "details-numbers-num-bonus-foreground",
                "details-shares-title-foreground",
                "details-shares-background",
                "details-shares-border",
                "details-shares-button-background",
                "details-shares-button-foreground",
                "details-shares-button-background-hover",
                "details-shares-button-foreground-hover",
                "details-shares-info-foreground"
            ]
        }, window.parent.location.origin);
    };
    Syndicate.prototype.showDraws = function () {
        window.parent.postMessage({
            key: BrandingBase.SelectBrandingKey,
            value: [
                //Text
                "sidebar-draws-remember-to-play",
                "sidebar-draws-draws",
                "sidebar-draws-draw",
                "sidebar-draws-line",
                //Colors
                "sidebar-border",
                "sidebar-draws-background",
                "sidebar-draws-foreground",
                "sidebar-draws-border",
                "sidebar-draws-background-hover",
                "sidebar-draws-background-selected",
                "sidebar-draws-save-up-background",
                "sidebar-draws-save-up-foreground",
                "sidebar-draws-check-box-border",
                "sidebar-draws-check-box-background",
                "sidebar-draws-check-box-selected-border",
                "sidebar-draws-check-box-selected-background",
                "sidebar-draws-check-box-tick-background",
                "sidebar-draws-price-was-foreground",
                "sidebar-draws-price-now-foreground",
            ]
        }, window.parent.location.origin);
    };
    Syndicate.prototype.showSummary = function () {
        window.parent.postMessage({
            key: BrandingBase.SelectBrandingKey,
            value: [
                //Text
                "sidebar-summary-draw",
                "sidebar-summary-draws",
                "sidebar-summary-lines",
                "sidebar-summary-discount",
                "sidebar-summary-total",
                "sidebar-summary-add-to-cart",
                "sidebar-summary-update",
                "sidebar-summary-get-tickets",
                "sidebar-summary-loading",
                "completed",
                "mobile-tickets-button-add",
                "update-cart",
                "tickets-confirmed",
                "tickets-added-to-cart",
                "no-tickets-to-add-to-cart",
                "failed-to-sidebar-purchase-tickets",
                "no-tickets-to-sidebar-purchase",
                "select-sidebar-draws-number",
                //Colors
                "sidebar-summary-tickets-tickets-foreground",
                "sidebar-summary-tickets-discount-foreground",
                "sidebar-summary-tickets-total-border",
                "sidebar-summary-tickets-total-foreground",
                "sidebar-summary-tickets-button-add-to-cart-background",
                "sidebar-summary-tickets-button-add-to-cart-hover-background",
                "sidebar-summary-tickets-button-add-to-cart-foreground",
                "sidebar-summary-tickets-button-add-to-cart-hover-foreground",
                "sidebar-summary-tickets-button-get-tickets-background",
                "sidebar-summary-tickets-button-get-tickets-hover-background",
                "sidebar-summary-tickets-button-get-tickets-foreground",
                "sidebar-summary-tickets-button-get-tickets-hover-foreground",
                "sidebar-summary-tickets-login-message-background",
                "sidebar-summary-tickets-login-message-foreground"
            ]
        }, window.parent.location.origin);
    };
    Syndicate = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [ClientLotteryClientService, Router,
            TokenClient, NotificationClientService,
            I18N, EventAggregator, DialogClientService,
            BindingSignaler, GamePlayerTicketClientService])
    ], Syndicate);
    return Syndicate;
}(BaseSyndicate));
export { Syndicate };
